import { tv } from "../../variants/tv.js";
const arrowSVGVariants = tv({
    slots: {
        root: 'fill-none w-[20px] h-[10px]',
        path1: 'fill-[canvas]',
        path2: 'fill-gray-200 dark:fill-none',
        path3: 'dark:fill-gray-300'
    }
});
export { arrowSVGVariants };
